import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiVersions } from './api-version';
import { BaseService } from './base.service';
import { CustomDocumentUploadFile } from '../components/custom-document-uploader/custom-document-upload-file';
import { map } from 'rxjs/operators';
import { buildFileUploadData } from '../components/document-upload/document-upload.helper';

@Injectable({
  providedIn: 'root',
})
export class CustomDocumentService extends BaseService {
  uploadDocument(
    file: CustomDocumentUploadFile,
    path: string,
    apiVersion: ApiVersions = ApiVersions.v0_1
  ): Observable<CustomDocumentUploadFile> {
    return this.doUpload(path, file, apiVersion).pipe(
      map((response: any) => {
        if (response) {
          file.isUploading = false;
          return file;
        }
        return null;
      })
    );
  }

  private doUpload(
    endpoint: string,
    file: CustomDocumentUploadFile,
    apiVersion: ApiVersions
  ): Observable<any> {
    const formData = buildFileUploadData(file.rawFile);
    return this.post(endpoint, formData, {}, apiVersion, true);
  }
}
